import { React } from "react";

// project-imports
import StencilBox from "../stencils/StencilBox";
import PostYouTubeVideoStencil from "../post/PostYouTubeVideoStencil";


// third-party
import { Link } from "react-router-dom";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import Layout from "../../common/Layout";
import SEO from "../../common/SEO";
import ScrollAnimation from "react-animate-on-scroll";

const GalleryStencil = ({ data }) => {

    return (
        <>

            <SEO title="Salesforce Tutorials | Longswitch Academy" /> {/* Set SEO title */}
            <Layout>
                <BreadcrumbOne
                    title="Salesforce Tutorials" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Salesforce Tutorials"
                />
                <div className="eduvibe-home-one-blog edu-elements-area edu-section-gap bg-image">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-5">
                                <div className="section-title text-start">
                                    <StencilBox
                                        className="pre-title stencil-sm-devic mb--10"
                                        width="50%"
                                        height="26px"
                                        backgroundColor="#F5F5F5"
                                    />
                                    <StencilBox
                                        className="pre-title stencil-sm-devic"
                                        width="90%"
                                        height="56px"
                                        backgroundColor="#F5F5F5"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="button-group isotop-filter filters-button-group d-flex justify-content-start justify-content-lg-end">
                                    <Link className="edu-btn-stencil">
                                        <StencilBox
                                            className="sf-blog-btn-stencil"
                                            width="223px"
                                            height="60px"
                                            backgroundColor="#F5F5F5"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="row g-5 mt--10 text-center">
                            {(data || [])?.map((item) => (
                                <div key={item?.id} className="col-12 col-sm-12 col-xl-4 col-md-6 d-flex justify-content-center">
                                    <PostYouTubeVideoStencil />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default GalleryStencil;
